import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogRef } from 'ngx-modialog';
import { Employment } from '../../../../common/models/employment';
import { EmploymentService } from '../employment.service';
import { UtilitiesService } from '../../../../common/shared/services/utilities.service';
import * as moment from 'moment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-employment-form',
  templateUrl: './employment-form.component.html',
  styleUrls: ['./employment-form.component.scss']
})
export class EmploymentFormComponent implements OnInit {

  isEdit = false;
  startDate = null;
  endDate = null;
  employment: Employment;

  constructor(
    @Inject(MAT_DIALOG_DATA) public inputEmployment: Employment,
    public dialogRef: MatDialogRef<EmploymentFormComponent>,
    private _employmentService: EmploymentService,
    private _utilitiesService: UtilitiesService) { }

  ngOnInit() {
    this.employment = new Employment();

    if (this.inputEmployment !== null) {
      this.isEdit = true;
      if (this.inputEmployment.startUnixTimestamp !== 0) {
        this.startDate = moment.unix(this.inputEmployment.startUnixTimestamp);
      }
      if (this.inputEmployment.endUnixTimestamp !== 0) {
        this.endDate = moment.unix(this.inputEmployment.endUnixTimestamp);
      }
      // Creating new instance/do a deep copy to not sync data between View and Edit.
      this.employment = JSON.parse(JSON.stringify(this.inputEmployment));
    }
  }

  update() {
    this.fixDates();
    this._utilitiesService.addMinorAction('UpdateMemberships');
    this._employmentService.updateEmployment(this.employment).subscribe(
      data => {
        this._utilitiesService.removeAction('UpdateMemberships');
        if (this._utilitiesService.getData(data)) {
          this.dialogRef.close('SuccessEdit');
        } else {
          this.dialogRef.close('ErrorEdit');
        }
      },
      err => {
        this._utilitiesService.handleErrors(err);
        this.dialogRef.close('Close');
      }
    );
  }

  create() {
    this.fixDates();
    this._utilitiesService.addMinorAction('CreateMemberships');
    this._employmentService.createEmployment(this.employment).subscribe(
      data => {
        this._utilitiesService.removeAction('CreateMemberships');
        if (this._utilitiesService.getData(data)) {
          this.dialogRef.close('SuccessCreate');
        } else {
          this.dialogRef.close('ErrorCreate');
        }
      },
      err => {
        this._utilitiesService.handleErrors(err);
        this.dialogRef.close('Close');
      }
    );
  }

  close() {
    this.dialogRef.close('Canceled');
  }

  createUpdateActionActive() {
    return (this._utilitiesService.isActionActive('CreateMemberships') ||
           this._utilitiesService.isActionActive('UpdateMemberships'));
  }


  private fixDates() {

    this.employment.startUnixTimestamp = this._utilitiesService.fixUTCUnixtimestamp(this.startDate);
    this.employment.endUnixTimestamp = this._utilitiesService.fixUTCUnixtimestamp(this.endDate);
  }

}
